jQuery(document).ready(function($) {
  $('.media-carousel').flickity({
    cellSelector: '.media-carousel-item',
    cellAlign: 'left',
    prevNextButtons: false,
    wrapAround: true,
		autoPlay: false,
		imagesLoaded: true,
    arrowShape: 'M31.12 23.253a2.129 2.129 0 0 1 0 3.415l-19.166 21.058H93.481A2.025 2.025 0 0 1 95.77 50.003a2.025 2.025 0 0 1-2.288 2.277H11.955L31.12 73.331a2.129 2.129 0 0 1 0 3.415 2.153 2.153 0 0 1-3.434 0q-22.599-24.75-22.885-25.043a2.311 2.311 0 0 1-.571-1.708 2.311 2.311 0 0 1 .571-1.708L27.689 23.253a2.873 2.873 0 0 1 3.434 0Z',
  });
	$(".reveal").find('.close-button').on("click", function(e) {
		e.preventDefault();
		var $reveal = $(this).parents('.reveal');
		$reveal.foundation('close');
	});

	$(window).on("load", function() {
		// open reveal if url has hash
		var urlHash = window.location.hash;
		if (urlHash) urlHash = urlHash.substring(1);
		switch (urlHash) {
			case 'director-letter':
				$('a.read-more[href="#director-letter"]').trigger("click");
				break;
			case 'president-letter':
				$('a.read-more[href="#president-letter"]').trigger("click");
				break;
		}
	});

	$('.reveal')
		.on('open.zf.reveal', function() {
			var $vimeoPlayer = $(this).find('.autoplay iframe');
			if ($vimeoPlayer.length > 0) {
				var vidsrc = $vimeoPlayer.attr('src');
				if (vidsrc.indexOf('autoplay=1') == -1) {
					$vimeoPlayer.attr('src','');
					$vimeoPlayer.attr('src',vidsrc+'?autoplay=1');
				}
			}
		})
		.on('closed.zf.reveal', function() {
			var $vimeoPlayer = $(this).find('iframe');
			if ($vimeoPlayer.length > 0) {
				var vidsrc = $vimeoPlayer.attr('src');
				vidsrc = vidsrc.replace('?autoplay=1', '');
				$vimeoPlayer.attr('src','');
				$vimeoPlayer.attr('src',vidsrc);	
			}
		});

})
